// Logique pure des écrans de proximité (lot L5-C1, M17) : libellés et tons des états, actes proposés pour un
// besoin selon son état et les droits (orienter vers un signalement ou un projet exige le droit du domaine
// cible), texte d'une orientation et des résultats agrégés d'une consultation. Le serveur refait tout.
import { CIBLES_ORIENTATION, ETATS_BESOIN_QUARTIER, ETATS_CONSULTATION_QUARTIER, type BesoinQuartier, type ConsultationQuartier, type EtatBesoinQuartier, type EtatConsultationQuartier, type EtatEngagementQuartier, type OrientationLue } from '@cc/contrats';
import type { TonEtat } from '@cc/ui';

export const TON_BESOIN: Record<EtatBesoinQuartier, TonEtat> = { exprime: 'signer', qualifie: 'attente', oriente: 'attente', traite: 'ok', rejete: 'neutre' };
export const TON_CONSULTATION: Record<EtatConsultationQuartier, TonEtat> = { brouillon: 'neutre', a_venir: 'attente', ouverte: 'signer', close: 'ok' };
export const TON_ENGAGEMENT: Record<EtatEngagementQuartier, TonEtat> = { pris: 'attente', en_cours: 'attente', tenu: 'ok', abandonne: 'neutre' };

export const libelleBesoin = (e: EtatBesoinQuartier) => ETATS_BESOIN_QUARTIER[e];
export const libelleConsultation = (e: EtatConsultationQuartier) => ETATS_CONSULTATION_QUARTIER[e];

export type ActeBesoin = 'qualifier' | 'rejeter' | 'orienter_signalement' | 'orienter_projet' | 'traiter';

export interface DroitsProximite {
  modifier: boolean;
  signalement: boolean;
  projet: boolean;
}

/** Actes proposés pour un besoin : la qualification précède l'orientation, l'orientation ne se remplace pas. */
export function actesBesoin(b: Pick<BesoinQuartier, 'etat' | 'orientation'>, d: DroitsProximite): ActeBesoin[] {
  const a: ActeBesoin[] = [];
  if (d.modifier && (b.etat === 'exprime' || b.etat === 'qualifie')) a.push('qualifier', 'rejeter');
  if (b.etat === 'qualifie' && !b.orientation) {
    if (d.signalement) a.push('orienter_signalement');
    if (d.projet) a.push('orienter_projet');
  }
  if (d.modifier && (b.etat === 'qualifie' || b.etat === 'oriente')) a.push('traiter');
  return a;
}

export function texteOrientation(o: OrientationLue | null): string {
  if (!o) return 'Non orienté';
  const cible = CIBLES_ORIENTATION[o.cible];
  if (!o.visible) return `${cible} (détail réservé aux agents habilités dans ce domaine)`;
  return `${cible} ${o.numero ?? ''}${o.libelle ? ` : ${o.libelle}` : ''}${o.etat ? ` (${o.etat})` : ''}${o.creee ? ', créé depuis le besoin' : ', lié à un objet existant'}`;
}

/** Résultats agrégés « option : n (p %) », jamais les répondants. */
export function texteResultats(c: Pick<ConsultationQuartier, 'resultats' | 'total_reponses'>): string[] {
  return c.resultats.map((r) => `${r.option} : ${r.reponses} réponse${r.reponses > 1 ? 's' : ''}${c.total_reponses > 0 ? ` (${Math.round((100 * r.reponses) / c.total_reponses)} %)` : ''}`);
}
